export default __webpack_public_path__ + "static/media/gp1.329dc965.png";